<template>
  <div class="shadow-md p-3">
      <div class="flex flex-wrap justify-around">
        <button class="btn btn-success" @click="nuevoUsu()">Nuevo</button>
        <input @change="buscarFiltros(1)" type="text" class="form-control w-40 h-10" v-model="filtroNombre" placeholder="Nombre..">
        <div class="flex flex-wrap justify-between gap-5">
          <select class="form-select w-40" name="" id="" v-model="filtroTipo">
            <option value="">Todos los tipos</option>
            <option value="cliente">Clientes</option>
            <option value="vendedor">Vendedores</option>
            <option value="supervisor">Supervisor</option>
            <option value="admin">Admin</option>
          </select>
          <select class="form-select w-40" name="" id="" v-model="filtroHab">
            <option value="">Todos los estados</option>
            <option value="1">Habilitados</option>
            <option value="0">No Habilitados</option>
          </select>
          <select class="form-select w-40" name="" id="" v-model="filtroAct">
            <option value="">Todos los estados</option>
            <option value="1">Activos</option>
            <option value="0">No Activos</option>
          </select>
        </div>
        <button :disabled="loading" class="btn btn-secondary" @click="buscarFiltros(1)">Buscar</button>
      </div>
      <div class="flex items-center justify-between mt-4" >
        <button
          @click="prevPage"
          :disabled="ultimoIndex == 1 || loading"
          class="btn btn-primary cursor-pointer hover:bg-blue-600 focus:outline-none"
        >
          Anterior
        </button>
        <p>Pag. {{ ultimoIndex }}</p>
        <button
          @click="nextPage"
          :disabled="loading"
          class="btn btn-primary cursor-pointer hover:bg-blue-600 focus:outline-none"
        >
          Siguiente
        </button>
      </div>
      <table class="table table-striped table-sm text-sm">
        <thead>
          <tr>
            <th scope="col">Opciones</th>
            <th @click="cambiarOrden('nombre')" scope="col">Nombre</th>
            <th @click="cambiarOrden('mail')" scope="col">Email</th>
            <th scope="col">CUIT</th>
            <th scope="col">Razon Social</th>
            <th @click="cambiarOrden('fecha')" scope="col">Fecha Alta</th>
            <th @click="cambiarOrden('tipo')" scope="col">Tipo Usuario</th>
            <th scope="col">Habilitado</th>
            <th scope="col">Activo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, key) in usuarios" class="px-0" :key="key">
            <td>
              <button @click="editarUsuario(key)" class="w-7 mr-1"><img src="../assets/icons/pencil.png" alt="Editar" title="Editar"></button>
              <button @click="carritoUsuario(key)" class="w-7 h-auto mr-1 rounded-full bg-truered"><img class="p-1" src="../assets/icons/shopping-cart.png" alt="Editar" title="Pedidos"></button>
              <!-- <button class="w-7"><img src="../assets/icons/bin.png" alt="Eliminar" title="Eliminar"></button> -->
            </td>
            <td>{{ user.nombre }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.cuit }}</td>
            <td>{{ user.razonSocial }}</td>
            <td>{{ formatFecha(user.fechaAlta) }}</td>
            <td class="ml-1">{{ user.tipo }}</td>
            <td>{{ user.habilitado ? 'si' : 'no' }}</td>
            <td>{{ user.activo ? 'si' : 'no' }}</td>
          </tr>
          <tr v-if="usuarios.length == 0">
            <td>No se encontraron usuarios con ese criterio de busqueda</td>
          </tr>
        </tbody>
      </table>

      <div class="modal fade" id="modalEditUser" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <form @submit.prevent="guardarModif()" @keydown.enter.prevent>
              <div class="modal-body">
                <div class="flex justify-between p-2">
                  <p>Email: </p>
                <input required placeholder="E-mail" type="text" class="form-control w-2/3" v-model="registro.email">
                </div>
                <div class="flex justify-between p-2">
                  <p>Contraseña: </p>
                  <input required placeholder="Contraseña" type="text" class="form-control w-2/3" v-model="registro.contra">
                </div>
                <div class="flex justify-between p-2">
                  <p>Cuit: </p>
                  <input required :disabled="registro.id" placeholder="CUIT" type="text" class="form-control w-2/3" @change="buscarCuit()" v-model="registro.cuit">
                </div>
                <div class="flex justify-between p-2">
                  <p>Nombre: </p>
                  <input required placeholder="Nombre" type="text" class="form-control w-2/3" v-model="registro.nombre">
                </div>
                <div class="flex justify-between p-2">
                  <p>Apellido: </p>
                  <input placeholder="Apellido" type="text" class="form-control w-2/3" v-model="registro.apellido">
                </div>
                <div class="flex justify-between p-2">
                  <p>Razon social: </p>
                  <input required :disabled="!!registro.id" :readonly="!registro.id" placeholder="Razón social" type="text" class="form-control w-2/3" v-model="registro.razonSocial">
                </div>
                <div class="flex justify-between p-2">
                  <p>Telefono: </p>
                  <input placeholder="Teléfono" type="phone" class="form-control w-2/3" v-model="registro.telefono">
                </div>
                <div class="flex justify-between p-2">
                  <p>Celular: </p>
                  <input placeholder="Celular" type="phone" class="form-control w-2/3" v-model="registro.celular">
                </div>
                <div class="flex justify-between p-2">
                  <p>Expreso: </p>
                  <select required placeholder="Seleccione un expreso" class="form-select w-2/3" v-model="registro.idexp">
                    <option value="" disabled selected hidden>Seleccione un expreso</option>
                    <option v-for="(ex, key) in expresos" :key="key" :value="ex.id">{{ ex.descripcion }}</option>
                  </select>
                </div>
                <div class="flex justify-between p-2">
                  <p>Zona: </p>
                  <select required placeholder="Seleccione una zona" class="form-select w-2/3" v-model="nuevoUsuBodell.zona">
                    <option value="" disabled selected hidden>Seleccione una zona</option>
                    <option v-for="(ex, key) in zonas" :key="key" :value="ex.id">{{ ex.descripcion }}</option>
                  </select>
                </div>
                <div class="flex justify-between p-2">
                  <p>Direccion: </p>
                  <input required placeholder="Dirección de entrega" id="none" autocomplete="off" ref="autocompleteInput" type="text" class="form-control w-2/3" v-model="registro.direccion">
                </div>
                <div class="flex justify-between p-2">
                  <p>Provincia: </p>
                  <select required placeholder="Seleccione una provincia" class="form-select w-2/3" v-model="registro.provincia">
                    <option value="" disabled selected hidden>Seleccione una provincia</option>
                    <option v-for="(prov, key) in provincias" :key="key" :value="prov.id">{{ prov.descripcion }}</option>
                  </select>
                </div>
                <div class="flex justify-between p-2">
                  <p>Ciudad: </p>
                  <input required placeholder="Ciudad" id="ciudad" type="text" class="form-control w-2/3" v-model="registro.ciudad">
                </div>
                <div class="flex justify-between p-2">
                  <p>Observacion: </p>
                  <textarea v-model="registro.obs" class="form-control w-2/3" id="" cols="30" rows="2"></textarea>
                </div>
                <div class="flex justify-between p-2">
                  <p>Tipo: </p>
                  <select required placeholder="Seleccione un tipo de usuario" class="form-select w-2/3" v-model="registro.tipo">
                    <option value="cliente">Cliente</option>
                    <option value="vendedor">Vendedor</option>
                    <option value="supervisor">Supervisor</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
                <div v-if="registro.tipo == 'cliente'" class="flex justify-between p-2">
                  <p>Tipo de Cliente: </p>
                  <select placeholder="Seleccione un tipo de cliente" class="form-select w-2/3" v-model="registro.idtipocli">
                    <option value="" disabled>Seleccione un tipo de cliente</option>
                    <option v-for="(tc, key) in tiposCliente" :key="key" :value="tc.id">{{ tc.descripcion }}</option>
                  </select>
                </div>
                <div v-if="registro.tipo != 'cliente'" class="flex justify-between p-2">
                  <p>Vendedor Asociado: </p>
                  <select placeholder="Seleccione un vendedor" class="form-select w-2/3" v-model="registro.idven">
                    <option value="" disabled selected hidden>Seleccione un vendedor</option>
                    <option v-for="(ex, key) in vendedores" :key="key" :value="ex.id">{{ ex.descripcion }}</option>
                  </select>
                </div>
                <div v-else-if="!usuarioNuevoBodell" class="flex justify-between p-2">
                  <p>Cliente Asociado: </p>
                  <div class="flex justify-around gap-1">
                    <input @change="buscarCli()" class="form-control" type="text" v-model="cliente.codigo">
                    <p>{{ cliente.nombre }}</p>
                    <button id="verBuscador" type="button" @click="buscarCuitAsociado(registro.cuit)" class="btn"><img src="../assets/icons/search.png" class="w-10" alt=""></button>
                  </div>
                </div>
                <div v-if="!usuarioNuevoBodell && verBuscadorCli && registro.tipo == 'cliente'" class="border m-1">
                  <input class="form-control" type="text" placeholder="Nombre/Cuit" v-model="cliente.nombre" @change="buscadorCli">
                  <div v-for="(cli, key) in clientes" :key="key" class="flex justify-between text-xs hover:bg-gray-200" @click="seleccionarCli(cli.codigo)">
                    <p>{{ cli.codigo }}</p>
                    <p>{{ cli.nombre }}</p>
                  </div>
                </div>
                <div class="flex justify-between p-2" v-if="usuarioNuevoBodellCheck">
                    <p>No se encontro el cliente en bodell, desea crear uno nuevo para este usuario?</p>
                    <input type="checkbox" v-model="usuarioNuevoBodell">
                </div>
                <div v-if="usuarioNuevoBodell">
                  <div class="flex justify-between p-2">
                    <p>Vendedor: </p>
                    <select required placeholder="Seleccione un vendedor" class="form-select w-2/3" v-model="nuevoUsuBodell.vendedor">
                      <option value="" disabled selected hidden>Seleccione un vendedor</option>
                      <option v-for="(ex, key) in vendedores" :key="key" :value="ex.id">{{ ex.descripcion }}</option>
                    </select>
                  </div>
                  <div class="flex justify-between p-2">
                    <p>Condicion de venta: </p>
                    <select placeholder="Seleccione una condicion de venta" class="form-select w-2/3" v-model="nuevoUsuBodell.condicion">
                      <option :value="1">1</option>
                      <option :value="2">2</option>
                      <option :value="4">4</option>
                    </select>
                  </div>
                  <div class="flex justify-between p-2">
                    <p>Bonificacion:</p>
                    <input required class="form-control w-2/3" type="number" min="0" max="100" v-model="nuevoUsuBodell.bonif">
                  </div>
                  <div class="flex justify-between p-2">
                    <p>Condicion de iva:</p>
                    <select placeholder="Seleccione una condicion de iva" class="form-select w-2/3" v-model="nuevoUsuBodell.iva">
                      <option v-for="(iva, key) in ivas" :key="key" :value="iva.id">{{ iva.descr }}</option>
                    </select>
                  </div>
                </div>
                <div class="flex justify-around p-2">
                  <p>Habilitado: </p>
                  <input placeholder="habilitado" id="habilitado" type="checkbox" class="form-checkbox" v-model="registro.habilitado">
                  <p>Activo: </p>
                  <input placeholder="activo" id="activo" type="checkbox" class="form-checkbox" v-model="registro.activo">
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-danger bg-truered" type="button" @click="cerrarModal()">Cancelar</button>
                <button class="btn btn-success bg-green-500" type="submit" :disabled="loading">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
  </div>
</template>
  
<script>
  import usuarioService from '@/services/usuario.service';
  import authService from '@/services/auth.service';
  import { applyPadronToRegistro } from '@/utils/afipPadron';
  export default {
    data() {
      return {
        loading: false,
        usuarios: [],
        filtro: '',
        ultimoIndex: 1,
        registro: {},
        expresos: [],
        zonas: [],
        vendedores: [],
        tiposCliente: [],
        filtroNombre: '',
        filtroTipo: '',
        filtroHab: '',
        filtroAct: '',
        provincias: [
          { id: 0, descripcion: "CABA" }, // Ciudad Autónoma de Buenos Aires
          { id: 1, descripcion: "Buenos Aires" },
          { id: 2, descripcion: "Catamarca" },
          { id: 3, descripcion: "Córdoba" },
          { id: 4, descripcion: "Corrientes" },
          { id: 5, descripcion: "Entre Ríos" },
          { id: 6, descripcion: "Jujuy" },
          { id: 7, descripcion: "Mendoza" },
          { id: 8, descripcion: "La Rioja" },
          { id: 9, descripcion: "Salta" },
          { id: 10, descripcion: "San Juan" },
          { id: 11, descripcion: "San Luis" },
          { id: 12, descripcion: "Santa Fe" },
          { id: 13, descripcion: "Santiago del Estero" },
          { id: 14, descripcion: "Tucumán" },
          { id: 16, descripcion: "Chaco" },
          { id: 17, descripcion: "Chubut" },
          { id: 18, descripcion: "Formosa" },
          { id: 19, descripcion: "Misiones" },
          { id: 20, descripcion: "Neuquén" },
          { id: 21, descripcion: "La Pampa" },
          { id: 22, descripcion: "Río Negro" },
          { id: 23, descripcion: "Santa Cruz" },
          { id: 24, descripcion: "Tierra del Fuego" },
        ],
        cliente: {},
        clientes: [],
        verBuscadorCli: false,
        usuarioNuevoBodellCheck: false,
        usuarioNuevoBodell: false,
        nuevoUsuBodell: {
          vendedor: '',
          bonif: 0,
          condicion: 1,
          iva: 1
        },
        ivas: [],
        loadingCuit: false,
        padronValido: false,
        cuitConsultado: ''
      };
    },
    mounted() {
      this.getAllUsers(1)
      this.getExpresos()
      this.getZonas()
      this.getVendedores()
      this.getIvas()
      this.getTiposCliente()
    },
    computed: {
    },
    methods: {
      getIvas() {
        usuarioService.getIvasBodell()
          .then((res) => {
            this.ivas = res.data
          })
          .catch((err) => {
            console.log(err)
          })
      },
      buscarCuitAsociado(cuit) {
        usuarioService.buscadorClienteBodellCuit(cuit)
          .then((ans) => {
            if (ans.data) {
              this.cliente.codigo = ans.data
              this.buscarCli()
              this.usuarioNuevoBodellCheck = false
            } else {
              this.verBuscadorCli = !this.verBuscadorCli
              this.usuarioNuevoBodellCheck = true
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      buscarCuit() {
        if (!this.registro.id && this.registro.cuit) {
          this.loadingCuit = true
          this.padronValido = false
          this.cuitConsultado = ''
          this.registro.razonSocial = ''
          authService.getPadron(this.registro.cuit)
            .then((res) => {
              this.loadingCuit = false
              console.log(res.data)
              if (res.data.cuit) {
                applyPadronToRegistro(this.registro, res.data)
                if (this.registro.razonSocial) {
                  this.padronValido = true
                  this.cuitConsultado = String(this.registro.cuit)
                }
              }
            })
            .catch((err) => {
              this.loadingCuit = false
              console.log(err)
            })
        }
      },
      carritoUsuario(key) {
        this.$router.push("usuarios/pedidos/" + this.usuarios[key].id)
      },
      buscarCli() {
        if (this.cliente.codigo) {
          usuarioService.buscarCliente(this.cliente.codigo)
            .then((res) => {
              if (res.data) {
                this.verBuscadorCli = false
                this.cliente = res.data
                this.registro.idcli = res.data.id
              } else {
                this.cliente = { codigo: this.cliente.codigo, nombre: 'No se encontro el cliente', id: '' }
                this.registro.idcli =null
              }
            })
            .catch((err) => {
              console.log(err)
              this.registro.idcli = null
            })
        }
      },
      buscarCliId() {
        if (this.registro.idcli) {
          usuarioService.buscarClienteId(this.registro.idcli)
            .then((res) => {
              if (res.data) {
                this.verBuscadorCli = false
                this.cliente = res.data
              } else {
                this.cliente = { codigo: this.cliente.codigo, nombre: 'No se encontro el cliente', id: '' }
                this.registro.idcli =null
              }
            })
            .catch((err) => {
              console.log(err)
              this.registro.idcli = null
            })
        }
      },

      zonaCli() {
        if (!this.registro.idcli) {
          return
        }
        usuarioService.buscarClienteIdZon(this.registro.idcli)
          .then((res) => {
            if (res.data) {
              this.nuevoUsuBodell.zona = res.data
            }
          })
          .catch((err) => {
            console.log(err)
            this.nuevoUsuBodell.zona = ''
          })
      },
      tipoClienteCli() {
        if (!this.registro.idcli) {
          return
        }
        usuarioService.buscarClienteTipo(this.registro.idcli)
          .then((res) => {
            // El endpoint devuelve directamente un número (ID del tipo de cliente)
            if (res.data != null && res.data !== '') {
              this.registro.idtipocli = parseInt(res.data)
              console.log('Tipo de cliente asignado:', this.registro.idtipocli)
            } else {
              this.registro.idtipocli = 1 // Por defecto "SIN TIPO"
            }
          })
          .catch((err) => {
            console.log('Error al cargar tipo de cliente:', err)
            this.registro.idtipocli = 1 // Por defecto "SIN TIPO" en caso de error
          })
      },
      seleccionarCli(codigo) {
        this.cliente.codigo = codigo
        this.buscarCli()
      },
      buscadorCli() {
        if (this.cliente.nombre) {
          usuarioService.buscadorCliente(this.cliente.nombre)
            .then((res) => {
              if (res.data.length > 0) {
                this.clientes = res.data
              } else {
                this.clientes = []
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      },
      buscarFiltros(num) {
        this.$nextTick(() => { 
        if (!this.loading) {
          this.loading = true
          usuarioService.getUsersFiltro(num, this.filtroNombre, this.filtroTipo, this.filtroHab, this.filtroAct)
            .then((res) => {
              this.loading = false
              if (res.data.length > 0) {
                this.usuarios = res.data
                this.ultimoIndex = num
              } else {
                this.usuarios = []
              }
            })
            .catch((res) => {
              this.loading = false
              console.log(res)
            })
          }
        })
      },
      nextPage() {
        this.buscarFiltros(this.ultimoIndex + 1)
      },
      prevPage() {
        this.buscarFiltros(this.ultimoIndex - 1)
      },
      getExpresos() {
        authService.expresos()
          .then((res) => {
            this.expresos = res.data.map(x => ({
              id: x.ID_EXP,
              descripcion: x.NOMBRE_EXP
            })).sort((a, b) => {
              const descripcionA = a.descripcion.toLowerCase();
              const descripcionB = b.descripcion.toLowerCase();

              if (descripcionA < descripcionB) {
                return -1;
              }
              if (descripcionA > descripcionB) {
                return 1;
              }
              return 0;
            })
          })
          .catch(err => {
            console.log(err)
          })
      },
      getZonas() {
        authService.zonas()
          .then((res) => {
            this.zonas = res.data.map(x => ({
              id: x.ID_ZON,
              descripcion: x.DESCRIPCION_ZON
            }))
          })
          .catch(err => {
            console.log(err)
          })
      },
      getVendedores() {
        usuarioService.getVendedores()
          .then((res) => {
            this.vendedores = res.data.map(x => ({
              id: x.ID_VC,
              descripcion: x.DESCRIP_VC
            }))
          })
          .catch(err => {
            console.log(err)
          })
      },
      getTiposCliente() {
        authService.tipoCliente()
          .then((res) => {
            this.tiposCliente = res.data.map(x => ({
              id: parseInt(x.ID_TCLI), // Asegurar que sea número
              descripcion: x.DESCRIP_TCLI
            }))
            console.log('Tipos de cliente cargados:', this.tiposCliente)
          })
          .catch(err => {
            console.log('Error al cargar tipos de cliente:', err)
          })
      },
      getAllUsers(num) {
        this.loading = true
        usuarioService.getAllUsers(num)
          .then((res) => {
            this.loading = false
            if (res.data.length > 0) {
              this.usuarios = res.data
              this.ultimoIndex = num
              var idusu = this.$route.query.idusu;
              if (idusu) {
                usuarioService.getUserId(idusu)
                  .then((usu) => {
                    this.registro = JSON.parse(JSON.stringify(usu.data))
                    if (this.registro.idcli) {
                      this.buscarCliId()
                    }
                    this.nuevoUsuBodell = {
                      vendedor: '',
                      bonif: 0,
                      condicion: 1,
                      iva: this.ivas.length > 0 ? this.ivas[0].id : 1
                    }
                    window.$('#modalEditUser').modal('show')
                  })
                  .catch((err) => console.log(err))
              }
            }
          })
          .catch((res) => {
            this.loading = false
            console.log(res)
          })
      },
      aplicarFiltros() {
        if (this.filtroNombre == '' && this.filtroMail == '') {
          this.getAllUsers(1)
        }
      },
      crearUsuarioBodell(usuario) {
        var user = {
          'usuarios': usuario,
          'condicion':  this.nuevoUsuBodell.condicion,
          'vendedor': this.nuevoUsuBodell.vendedor,
          'bonif': this.nuevoUsuBodell.bonif,
          'iva': this.nuevoUsuBodell.iva,
          'zona': this.nuevoUsuBodell.zona,
          'tipoCli': this.nuevoUsuBodell.tipoCli
        }
        usuarioService.modifUserBodell(user)
          .then(() => {
            this.cerrarModal()
            this.loading = false
            this.buscarFiltros(this.ultimoIndex)
            this.$root.alertSuccess = true
            this.$root.alertMessage = 'Cliente creado correctamente'
            this.$root.isAlertVisible = true
          })
          .catch((err) => {
            this.loading = false
            if (err.response && err.response.status == 501) {
              this.$root.alertSuccess = false
              this.$root.alertMessage = 'El CUIT y/o MAIL ya están en uso'
              this.$root.isAlertVisible = true
            } else {
              const data = err.response && err.response.data
              let msg = 'Error al crear el cliente. Intente nuevamente.'
              if (data) {
                if (data.message) msg = data.message
                else if (data.error) msg = data.error
                if (data.field) msg += ' (campo: ' + data.field + ')'
              }
              this.$root.alertSuccess = false
              this.$root.alertMessage = msg
              this.$root.isAlertVisible = true
              console.error('crearUsuarioBodell error:', err)
            }
          })
      },
      guardarModif() {
        this.loading = true
        var usuario = this.registro
        if (!usuario.id && usuario.tipo == 'cliente' && (!this.padronValido || String(usuario.cuit) !== this.cuitConsultado)) {
          this.loading = false
          this.$root.alertSuccess = false
          this.$root.alertMessage = 'Debe consultar un CUIT válido en AFIP antes de guardar'
          this.$root.isAlertVisible = true
          return
        }
        if (usuario.tipo == 'cliente') {
          usuario.idven = null
          // Asegurar que el tipo de cliente esté en nuevoUsuBodell para cuando se crea en Bodell
          this.nuevoUsuBodell.tipoCli = usuario.idtipocli ?? 1
        } else {
          usuario.idcli = null
          usuario.idtipocli = null
        }
        if (this.usuarioNuevoBodell) {
          this.crearUsuarioBodell(usuario)
          return
        }
        if (usuario.idcli && this.nuevoUsuBodell.zona != null && this.nuevoUsuBodell.zona != '') {
          usuarioService.modifZona(usuario.idcli, this.nuevoUsuBodell.zona)
            .catch((err) => {
              console.log(err)
            })
        }
        usuarioService.modifUser(usuario)
          .then(() => {
            this.cerrarModal()
            this.loading = false
            this.buscarFiltros(this.ultimoIndex)
            this.$root.alertSuccess = true
            this.$root.isAlertVisible = true
          })
          .catch((err) => {
            this.loading = false
            if (err.response.status == '501') {
              alert('EL CUIT y/o MAIL ya estan en uso')
            } else {
              this.cerrarModal()
              console.log(err)
              this.$root.alertSuccess = false
              this.$root.isAlertVisible = true
            }
          })
      },
      editarUsuario(index) {
        this.cliente = {}
        this.registro = JSON.parse(JSON.stringify(this.usuarios[index]))
        // Establecer valor por defecto si no tiene tipo de cliente
        if (this.registro.tipo == 'cliente' && !this.registro.idtipocli) {
          this.registro.idtipocli = 0 // 0 corresponde a "SIN TIPO"
        }
        if (this.registro.idcli) {
          this.buscarCliId()
        }
        this.nuevoUsuBodell = {
          vendedor: '',
          bonif: 0,
          condicion: 1,
          iva: this.ivas.length > 0 ? this.ivas[0].id : 1
        }
        this.zonaCli()
        // Solo buscar tipo de cliente si el usuario es de tipo "cliente"
        if (this.registro.tipo == 'cliente') {
          this.tipoClienteCli()
        }
        window.$('#modalEditUser').modal('show')
      },
      nuevoUsu() {
        this.cliente = {}
        this.padronValido = false
        this.cuitConsultado = ''
        this.registro = {
          idtipocli: 1 // Valor por defecto "SIN TIPO"
        }
        this.nuevoUsuBodell = {
          vendedor: '',
          bonif: 0,
          condicion: 1,
          iva: this.ivas.length > 0 ? this.ivas[0].id : 1
        }
        window.$('#modalEditUser').modal('show')
      },
      cerrarModal() {
        this.usuarioNuevoBodellCheck = false
        this.padronValido = false
        this.cuitConsultado = ''
        window.$('#modalEditUser').modal('hide')
      },
      formatFecha(fecha) {
        var splited = fecha.split('-')
        var fechaFormated = splited[2] + '/' + splited[1] + '/' + splited[0]
        return fechaFormated
      },
      cambiarOrden() {
        // if (filtro == 'mail') {
        //   if (this.filtro == 'mail') {
        //     this.filtro = 'mailR'
        //     this.usuarios = this.usuarios.sort((a,b) => {
        //       if (a.email > b.email) {
        //         return -1
        //       } else if (b.email > a.email) {
        //         return 1
        //       }
        //       return 0
        //     })
        //   } else {
        //     this.filtro = 'mail'
        //     this.usuarios = this.usuarios.sort((a,b) => {
        //       if (a.email > b.email) {
        //         return 1
        //       } else if (b.email > a.email) {
        //         return -1
        //       }
        //       return 0
        //     })
        //   }
        // } else if (filtro == 'nombre') {
        //   if (this.filtro == 'nombre') {
        //     this.filtro = 'nombreR'
        //     this.usuarios = this.usuarios.sort((a,b) => {
        //       if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
        //         return -1
        //       } else if (b.nombre.toLowerCase() > a.nombre.toLowerCase()) {
        //         return 1
        //       }
        //       return 0
        //     })
        //   } else {
        //     this.filtro = 'nombre'
        //     this.usuarios = this.usuarios.sort((a,b) => {
        //       if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
        //         return 1
        //       } else if (b.nombre.toLowerCase() > a.nombre.toLowerCase()) {
        //         return -1
        //       }
        //       return 0
        //     })
        //   }
        // } else if (filtro == 'fecha') {
        //   console.log(filtro)
        //   if (this.filtro == 'fecha') {
        //     console.log(1)
        //     this.filtro = 'fechaR'
        //     this.usuarios = this.usuarios.sort(function(a,b) {
        //       return new Date(b.fechaAlta) - new Date(a.fechaAlta)
        //     })
        //   } else {
        //     console.log(2)
        //     this.filtro = 'fecha'
        //     this.usuarios = this.usuarios.sort(function(a,b) {
        //       return new Date(a.fechaAlta) - new Date(b.fechaAlta)
        //     })
        //   }
        // } else if (filtro == 'tipo') {
        //   if (this.filtro == 'tipo') {
        //     this.filtro = 'tipoR'
        //     this.usuarios = this.usuarios.sort((a,b) => {
        //       if (a.tipo > b.tipo) {
        //         return -1
        //       } else if (b.tipo > a.tipo) {
        //         return 1
        //       }
        //       return 0
        //     })
        //   } else {
        //     this.filtro = 'tipo'
        //     this.usuarios = this.usuarios.sort((a,b) => {
        //       if (a.tipo > b.tipo) {
        //         return 1
        //       } else if (b.tipo > a.tipo) {
        //         return -1
        //       }
        //       return 0
        //     })
        //   }
        // }
      }
    }

  };
</script>

<style>
  tr td{
    padding: 0 !important;
    margin: 0 !important;
    height: 28px !important;
  }
</style>

